import axios from 'axios';

const ENCOMPASS_INT_API_URI = process.env.REACT_APP_INTEGRATION_API as string;
const ENCOMPASS_PLUGIN_API_URI = process.env.REACT_APP_DT_PLUGIN_API_URI;
const ENCOMPASS_TOKEN_ENDPOINT_API_URI = process.env.REACT_APP_DT_TOKEN_ENDPOINT_API_URI;
const ENCOMPASS_PUHSBACK_API_URI = process.env.REACT_APP_DT_PUSHBACK_API_URI;
const ENCOMPASS_DEFAULT_INSTANCE_ID = process.env.REACT_APP_DT_DEFAULT_ENCOMPASS_INSTANCEID as string; // Temporary
const ENCOMPASS_DEFAULT_CONFIG_ID = process.env.REACT_APP_DT_DEFAULT_CONFIG_ID as string; // Temporary
const REACT_APP_EPC_API = process.env.REACT_APP_EPC_API;

class EncompassService {
    private baseURL: string;

    constructor(baseURL: string) {
        this.baseURL = baseURL;
    }

    public async ping(): Promise<boolean> {
        try {
           
            const response = await axios.get(`${this.baseURL}/ping`);

            if (response.status === 200) {
                if (response.data) {
                    return true;
                }
            }

            return false;

        } catch (error) {
            console.log("Encompass Service Test Connection: ", error);
            return false; 
        }
    }

    public static getRequestEndpoint() { 
        return this.compareLocalStorageWithEnv("integrationUri", ENCOMPASS_INT_API_URI)
    }
    public static getPluginEndpoint() { return localStorage.getItem("pluginUri") ?? ENCOMPASS_PLUGIN_API_URI; }
    public static getTokenEndpoint() { return localStorage.getItem("tokenUri") ?? ENCOMPASS_TOKEN_ENDPOINT_API_URI; }
    public static getPushbackEndpoint() { return localStorage.getItem("pushbackUri") ?? ENCOMPASS_PUHSBACK_API_URI; }
    public static getExpressionValidationEndpoint() { return REACT_APP_EPC_API; }
    public static getEncompassInstanceId() { return localStorage.getItem("encompassInstanceId") ?? ENCOMPASS_DEFAULT_INSTANCE_ID; }

    // TODO: These should come from state 
    public static getConfigId() { return localStorage.getItem("configurationId") ?? ENCOMPASS_DEFAULT_CONFIG_ID; }

    // generic method to compare local storage key value with with Environment value
    // Can be used in future for other endpoint If we change the environment variables
    public static compareLocalStorageWithEnv(key: string, env: string ) {
        if (localStorage.getItem(key) !== env) {
            localStorage.setItem(key, env);
            return env;
        }
        else {
            return localStorage.getItem(key) ?? env;
        }
    }

}

export default EncompassService;